/**
 * BUTTON WITH INNER SPINNER
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function ButtonWithInnerSpinner(
    {
        buttonType,
        buttonClass,
        buttonClick,
        buttonMessageId,
        buttonState
    }
) {

    //default 'type' values
    let setButtonType;
    if (buttonType) {
        setButtonType = buttonType;
    } else {
        setButtonType = 'button';
    }

    //default 'class' value
    let setButtonClass;
    if (buttonClass) {
        setButtonClass = buttonClass;
    } else {
        setButtonClass = "button-primary-lg";
    }

    let setButtonClick;
    if (buttonClick) {
        setButtonClick = buttonClick;
    } else {
        setButtonClick = null;
    }

    let setButtonMessageId;
    if (buttonMessageId) {
        setButtonMessageId = buttonMessageId;
    } else {
        setButtonMessageId = null;
    }

    /*
     FormattedMessage generates the span that has the spinner image background,
     and buttonMessageId with color transparent is used to prevent width flickers
     when buttons are used one next to another
     */
    switch (buttonState) {
        case "loading":
            return (
                <button className={setButtonClass + " bwis-loading"}>
                    {setButtonMessageId ? <FormattedMessage id={setButtonMessageId} /> : <span />}
                </button>
            );

        case "enabled":
            return (
                <button type={setButtonType}
                        className={setButtonClass + " bwis-enabled"}
                        onClick={setButtonClick}>
                    {setButtonMessageId ? <FormattedMessage id={setButtonMessageId} /> : <span />}
                </button>
            );

        case "disabled":
            return (
                <button type={setButtonType}
                        className={setButtonClass + " bwis-disabled"}
                        disabled>
                    {setButtonMessageId ? <FormattedMessage id={setButtonMessageId} /> : <span />}
                </button>
            );

        case "error":
            return (
                <button type={setButtonType}
                        className={setButtonClass + " bwis-error"}
                        disabled>
                    <span>ERROR</span>
                </button>
            );

        default:
            return (
                <button type={setButtonType}
                        className={setButtonClass + " bwis-default"}
                        onClick={setButtonClick}>
                    {setButtonMessageId ? <FormattedMessage id={setButtonMessageId} /> : <span />}
                </button>
            );
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/ButtonWithInnerSpinner/ButtonWithInnerSpinner.index.jsx